import { useEffect } from "react";

/** Hide the platform's "Made with Emergent" badge for the lifetime of the component. */
export function useHideEmergentBadge() {
  useEffect(() => {
    const hide = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.style.setProperty("display", "none", "important");
    };
    hide();
    const id = setInterval(hide, 500);
    return () => {
      clearInterval(id);
      const el = document.getElementById("emergent-badge");
      if (el) el.style.removeProperty("display");
    };
  }, []);
}
